import "./CircularLoader.css";

const CircularLoader = () => {
	return (
		<div class="loader-container">
			<div class="loader"></div>
			<p>Please wait, setting up the simulator</p>
		</div>
	);
};

export default CircularLoader;